import request from '@/utils/request2';

//获取模板列表

export function getNoticeTemplateList(data) {
  return request.post('admin/notice-template/list', data);
}
//获取模板详情
export function getNoticeTemplateDetail(data) {
  return request.post('admin/notice-template/detail', data);
}
//新增模板
export function storeNoticeTemplate(data) {
  return request.post('admin/notice-template/store', data);
}
//编辑模板
export function editNoticeTemplate(data) {
  return request.post('admin/notice-template/edit', data);
}
//删除模板
export function deleteNoticeTemplate(data) {
  return request.post('admin/notice-template/delete', data);
}
//模板状态修改
export function changeNoticeTemplateStatus(data) {
  return request.post('admin/notice-template/status', data);
}